import { fetchData } from './api';
import { handleError } from '../context/errors/errorUtils';

const createGameFormData = (data) => {
  const formData = new FormData();
  const allowedFields = [
    'gameId',
    'stepId',
    'step',
    'userId',
    'userText',
    'completeGame',
    'correctAnswer',
    'difficulty',
    'round',
    'phrasesCount',
    'score',
    'gameDuration',
    'averagePhraseTime'
  ];

  if (data.audioBuffer) {
    formData.append('audio', new Blob([data.audioBuffer], { type: 'audio/wav' }), 'audio.wav');
  }

  Object.entries(data).forEach(([key, value]) => {
    if (allowedFields.includes(key) && value !== undefined) {
      formData.append(key, value);
    }
  });
  return formData;
};

export const sendPathGameData = async (data = {}) => {
  try {
    const formData = createGameFormData(data);
    return await fetchData('/api/path/game', 'POST', formData);
  } catch (error) {
    handleError({
      code: 'PATH_GAME_DATA_FETCH_ERROR',
      error,
      context: { module: 'sendPathGameData', gameId: data.gameId, stepId: data.stepId, userId: data.userId },
      showToUser: false
    });
    throw error;
  }
};

export const fetchPathGame = async ({ userId, stepId, setData, setGameId, setLoading, setError, difficulty }) => {
  try {
    const response = await sendPathGameData({ userId, stepId, difficulty });
    const { gameId, data: sentences } = response;
    if (!gameId || !sentences) {
      throw new Error('Некорректный ответ path game');
    }
    setData?.(sentences);
    setGameId?.(gameId);
    return { gameId, sentences };
  } catch (error) {
    setError?.(error);
    throw error;
  } finally {
    setLoading?.(false);
  }
};

export const sendPathGameScoresToServer = async ({
  gameId,
  pathStepId,
  stepId,
  userId,
  completeGame = true,
  score,
  phrasesCount,
  round,
  difficulty,
  gameDuration,
  averagePhraseTime
}) => {
  try {
    return await sendPathGameData({
      gameId,
      stepId: pathStepId,
      userId,
      step: stepId,
      completeGame,
      score,
      phrasesCount,
      round,
      difficulty,
      gameDuration,
      averagePhraseTime
    });
  } catch (error) {
    handleError({
      code: 'PATH_GAME_RESULT_FAILED',
      error,
      context: { module: 'sendPathGameScoresToServer', gameId, pathStepId, stepId, userId },
      showToUser: false
    });
    throw error;
  }
};
